export default __webpack_public_path__ + "media/react/mcat/pages/lesson_series/assets/shield_needs_work-501ab9bc7d0fa7f91dc037fc55e01136.png";